@defer {
    <section [id]="type" class="articles" animate.enter="enter-animation">
        <app-sponsor-banner [sponsor_key]="'news-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>

        @for (article of news_articles(); track $index) {
            @if ($index > 0 && $index % 5 === 0) {
                <app-sponsor-banner [sponsor_key]="'news-list'" [aspect_ratio]="'9:1'"> </app-sponsor-banner>
            }

            <div class="article-container" (click)="openLink(article)">
                <app-image [image_url]="article.image_url" [width]="'100%'" [height]="'100%'" [border_radius]="'4px'" [type]="handleType(article.type)"></app-image>
                <div class="article-content">
                    <div class="article-type">{{ handleType(article.type) }}</div>
                    <div class="article-title">{{ article.title }}</div>
                    <time class="article-date">{{ article.publication_date | date: 'mediumDate' }}</time>
                </div>

                @if (!(article.type === 'paid_content')) {
                    <div class="share-like-container">
                        <!-- <div class="share-like">
                            <span class="material-icons-outlined">reply </span>
                            <span class="share">Share</span>
                        </div> -->
                        <button mat-button (click)="shareArticle($event, article)"><mat-icon>reply</mat-icon> Share</button>
                        <div class="share-like">
                            <!-- <span class="material-icons-outlined" *ngIf="!currentFanLikes(article.likes)">thumb_up </span>
                        <span class="material-icons" *ngIf="currentFanLikes(article.likes)">thumb_up </span> -->
                            <!-- <span class="like">{{ article.likes.length }}</span> -->
                        </div>
                    </div>
                }
            </div>
        }
        <div appIntersectionObserver [threshold]="0.1" (isIntersecting)="handleNewsArticle($event)" [class.visible]="isVisible()" [isContinuous]="true">
            <app-loading-indicator></app-loading-indicator>
        </div>
    </section>
} @placeholder {
    <div style="height: calc(100% - 120px)">
        <app-loading-indicator></app-loading-indicator>
    </div>
}
